import { render, staticRenderFns } from "./BriefCard.vue?vue&type=template&id=72e2040c&scoped=true&"
import script from "./BriefCard.vue?vue&type=script&lang=js&"
export * from "./BriefCard.vue?vue&type=script&lang=js&"
import style0 from "./BriefCard.vue?vue&type=style&index=0&id=72e2040c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e2040c",
  null
  
)

export default component.exports